import React from 'react';
import useGoogleMapsLoader from '../../hooks/useGoogleMapsLoader';

function GoogleMapContainer({ children, loadingElement }) {
  const { isLoaded, loadError } = useGoogleMapsLoader();

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  if (!isLoaded) {
    return loadingElement || <div>Loading...</div>;
  }

  return children;
}

export default GoogleMapContainer;
